import React from 'react';
import DOMPurify from 'dompurify';
import styles from './SanitizedHtmlPreview.module.scss';

interface SanitizedHtmlPreviewProps {
  html: string;
  className?: string;
}

export function SanitizedHtmlPreview(props: SanitizedHtmlPreviewProps) {
  return (
    <div
      className={[styles.htmlPreview, props.className].filter(Boolean).join(' ')}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.html) }}
    />
  );
}
